import {AppError} from '@/plugins/axios';
import _ from 'lodash';
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

export namespace IRequestAuth {

  export enum Action {
    Auth = 'auth',
    RegistrationCreate = 'registration_create',
    RegistrationConfirm = 'registration_confirm',
  }

  export enum Command {
    Login = 'login',
    ReLogin = 'reLogin',
    Logout = 'logout',
    CheckToken = 'checkToken',
    RecoverPassword = 'forgotPassword',
    RemoveCorp = 'delPerson',
  }

  export enum ErrorCode {
    InvalidLoginOrPassword = 471,
    TokenNotFound = 475,
    TokenInvalid = 476,
    TokenExpired = 477,
  }

  export interface IAuthDataResponse {
    token: string;
    profileName: string;
    needReload: boolean;
    userAccess: IAuth.UserAccess;
  }

  export interface ILoginUserCorpsData {
    corpId: number;
    corpName: string;
    loginId: number;
    privatFlag: boolean;
    carCnt: number;
  }

  export function prepareAuthData(data: IAuth.UserAccess): IAuthDataResponse {
    const result: IAuthDataResponse = {
      token: data.token,
      profileName: data.persName ? data.persName : '',
      needReload: data.newVersion,
      userAccess: data,
    };

    return result;
  }

  export function isAuthError(error: Error) {
    const statuses = [
      ErrorCode.InvalidLoginOrPassword,
      ErrorCode.TokenNotFound,
      ErrorCode.TokenInvalid,
      ErrorCode.TokenExpired,
    ];

    return error instanceof AppError && _.includes(statuses, error.status);
  }
}
